import { SectionShell } from "@/components/dash/primitives";
import { FileText } from "lucide-react";

export default function Sources({ data, footer }) {
  return (
    <SectionShell id="sources" num="" title="Sources">
      <ul className="space-y-4 max-w-4xl" data-testid="sources-list">
        {data.map((s, i) => (
          <li key={i} className="flex gap-4 bg-white border border-slate-200 rounded-xl p-5">
            <div className="w-8 h-8 rounded-lg bg-slate-100 flex items-center justify-center shrink-0">
              <FileText className="w-4 h-4 text-slate-500" />
            </div>
            <p className="text-sm text-slate-600 leading-relaxed">{s}</p>
          </li>
        ))}
      </ul>
      <p className="text-xs text-slate-400 mt-10 max-w-4xl border-t border-slate-200 pt-6">{footer}</p>
    </SectionShell>
  );
}
